import { Component, OnInit, TemplateRef } from '@angular/core';
import { ApiHandlerService } from '../../../shared/services/api-handler.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { CmnFunctionService } from "../../../shared/services/cmn-function.service";
import { Router } from '@angular/router';
import { ConfirmationComponent } from '../../../shared/modal/confirmation/confirmation.component';
declare var $;
import { StorageService } from "../../../shared/services/storage.service";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { SocketService } from '../../services/socket.service';
import Swal from 'sweetalert2';

declare let swal: any;
declare let google: any;
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [ConfirmationComponent]
})
export class SettingsComponent implements OnInit {

  //declare global variable....
  curruntSettingsTabId: number = 1;
  public isLoading: boolean = false;
  message: string;
  public isContactNotFound: boolean = false;
  public isNotificationNotFound: boolean = false;
  public isPlacesNotFound: boolean = false;
  public isLoadingContact: boolean = false;
  public sosList: any = [];
  public contactList: any = [];
  public placesList: any = [];
  public notificationsList: any = [];
  public detail: any;
  public settingObject: any;
  public isLoadData: boolean = false;
  public role: any;

  public isNotificationReaded: boolean = false;

  // public isLoadingData : boolean = false;
  public addFavPlaceForm: FormGroup;
  public isLoadingFavPlaceData: boolean = false;
  public submitted: boolean = false;
  closeResult = '';
  public editFavPlaceForm: FormGroup;
  public isLoadingFavPlaceDataEdit: boolean = false;
  public submittedEdit: boolean = false;
  public efavAddName = '';
  public efavAddTitle = '';
  public efavAddId = '';

  public favPlaceList: any;

  public notificationOffset = 1;
  public isNotiNext = false;
  public isNotiPrev = false;

  coordinates = {
    lat: '',
    lon: ''
  }
  formattedaddress = "";
  options = {
    componentRestrictions: {
      country: []
    }
  }
  coordinatesEdit = {
    lat: '',
    lon: ''
  }
  formattedaddressEdit = "";

  constructor(
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    public _service: ApiHandlerService,
    public toaster: ToasterService,
    public modal: ConfirmationComponent,
    public router: Router,
    public storage: StorageService,
    public socket: SocketService,
    public cmnFunction: CmnFunctionService) {
    this.role = this.storage.getUserRole();
  }

  public handleAddressChange(address: any) {
    //setting address from API to local variable 
    this.addFavPlaceForm.controls.name.setValue(address.adr_address.replace(/<\/?[^>]+(>|$)/g, ""));
    this.coordinates.lat = address.geometry.location.lat();
    this.coordinates.lon = address.geometry.location.lng();

    // debugger;
    this.formattedaddress = address.formatted_address
  }
  public handleAddressChangeEdit(address: any) {
    //setting address from API to local variable 
    this.editFavPlaceForm.controls.name.setValue(address.adr_address.replace(/<\/?[^>]+(>|$)/g, ""));
    this.coordinatesEdit.lat = address.geometry.location.lat();
    this.coordinatesEdit.lon = address.geometry.location.lng();
    // debugger;
    this.formattedaddressEdit = address.formatted_address
  }


  ngOnInit(): void {
    //


    this.getActive()
    this.getFavPlace();
    //getContactList for getContactList..
    this.fetchSettingViaToken();
    this.getContactList(this.isLoadingContact);

    //below we initialize the validations...
    // this.addFavPlaceForm = this.formBuilder.group({
    //   type: ['', Validators.required],
    //   name: ['', [Validators.required]],
    // })

    this.addFavPlaceForm = new FormGroup({
      type: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
    });

    document.getElementById("notiBtn").onclick = () => {
      if (this.curruntSettingsTabId != <any>'4') {
        this.getActive()
        this.isLoadingContact = false;
      }
    }
    if (!this.socket.socket) this.socket.initSocket();
    this.socket.onEvent("notify").subscribe((result) => {
      this.getNotificationsList()
    });

  }

  getActive() {
    if (localStorage.getItem('currentTab') != null) {
      this.curruntSettingsTabId = <any>localStorage.getItem('currentTab');
      this.curruntSettingsTabId == <any>'4' ? this.getNotificationsList() : '';
      this.isLoadingContact = true;
    }
  }
  getFavPlace() {
    this._service.apiGet(this._service.baseUrl + 'fav-get').subscribe({
      next: result => {
        if (result['status']) {
          this.favPlaceList = result.data;
        } else {
          this.toaster.Error(result['message']);
          // this.isLoadingFavPlaceData = false;
        }
      }, error: err => {
        this.isLoadingFavPlaceData = false;
        this.toaster.Error(err.message);
      }
    });
  }

  // Custom whitespace validator
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  abc() {
    // console.log(`ragnor===============`)
  }


  deleteFavPlace(id) {
    console.log('deleteFavPlace-- ' + id);
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {


          this._service.apiDelete(this._service.baseUrl + '/fav-delete/' + id).subscribe({
            next: result => {
              // debugger;
              // this.pets.filter(function (elem) { return elem._id !== id; });
              this.favPlaceList = this.favPlaceList.filter(item => item._id != id);
              if (result['status']) {
                swal(result['message'], {
                  icon: "success",
                });

              } else {
                swal(result['message'], "error");
              }
            }, error: err => {

            }
          });
        } else {

        }
      });
  }

  // convenience getter for easy access to form fields
  get f() { return this.addFavPlaceForm.controls; }
  get fe() { return this.editFavPlaceForm.controls; }

  addFavPlace() {
    this.submitted = true;
    if (this.addFavPlaceForm.invalid) return;
    this.isLoadingFavPlaceData = true;
    var apidata = {
      type: this.addFavPlaceForm.value.type,
      name: this.addFavPlaceForm.value.name,
      // name: this.formattedaddress,
      coordinates: this.coordinates
    }
    this._service.apiPost(this._service.baseUrl + 'fav-add', apidata).subscribe({
      next: result => {
        // debugger;
        if (result['status']) {
          this.getFavPlace();
          this.toaster.Success(result['message']);
          this.isLoadingFavPlaceData = false;
          this.submitted = false;
          this.addFavPlaceForm.reset();
          this.formattedaddress = '';
        } else {
          this.toaster.Error(result['message']);
          this.isLoadingFavPlaceData = false;
        }
      }, error: err => {
        this.isLoadingFavPlaceData = false;
        this.toaster.Error(err.message);
      }
    });

  }
  editFavPlaceSubmit() {

    this.submittedEdit = true;
    if (this.editFavPlaceForm.invalid) return;
    this.isLoadingFavPlaceDataEdit = true;
    var apidata = {
      type: this.editFavPlaceForm.value.type,
      name: this.editFavPlaceForm.value.name,
      // name: this.formattedaddress,
      coordinates: this.coordinates
    }




    this._service.apiUpdate(this._service.baseUrl + 'fav-edit/' + this.efavAddId, apidata).subscribe({
      next: result => {
        // debugger;
        if (result['status']) {
          this.formattedaddressEdit = '';
          for (let fav of this.favPlaceList) {
            if (fav._id == this.efavAddId) {
              fav.name = this.editFavPlaceForm.get('name').value;
              fav.type = this.editFavPlaceForm.get('type').value;
            }
          }
          this.toaster.Success(result['message']);
          this.isLoadingFavPlaceDataEdit = false;
          this.submittedEdit = false;
          this.modalService.dismissAll();
        } else {
          this.toaster.Error(result['message']);
          this.isLoadingFavPlaceDataEdit = false;
        }
      }, error: err => {
        this.isLoadingFavPlaceDataEdit = false;
        this.toaster.Error(err.message);
      }
    });

  }

  settingsTab(id) {
    this.curruntSettingsTabId = id;
    localStorage.setItem('currentTab', <any>this.curruntSettingsTabId);
  }

  //getContactList for get contact list....
  getContactList(value) {
    this.isLoadingContact = value;

    //apiPost function for post data to Db...
    this._service.apiGet(this._service.baseUrl + '/contacts').subscribe({
      next: result => {
        if (result.status) {
          //here we will catch response...
          this.sosList = result.data.sos;
          this.contactList = result.data.contacts;
          this.isLoadingContact = false;

          if (this.contactList.length > 0) {
            //set for set key.....
            this.contactList.forEach(contactObj => {
              contactObj.key = contactObj.name.substring(0, 1).toUpperCase();
            });
          } else {
            this.isContactNotFound = true;
          }
          this.isLoadingContact = false;
        } else {
          this.toaster.Error(result.message);
        }
      }, error: err => {
        let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
        this.isLoading = false;
        this.toaster.Error(msg);
      }
    });
  }

  //AddEditContact for add or edit contact...
  AddEditContact(contact: any) {
    var obj;
    if (contact == '') {
      obj = { isEditPage: false };
    } else {
      obj = Object.assign({ isEditPage: true }, contact);
    }

    //if role is Customer
    if (JSON.parse(localStorage.getItem('userData')).role == 'Customer') {
      this.router.navigate(['customer/add-edit-sos-contact'], { state: { data: obj } });
    } else {
      this.router.navigate(['driver/add-edit-sos-contact'], { state: { data: obj } });
    }
  }

  getDetail(value) {
    this.detail = value;
  }
  deleteNoti(value) {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Notification!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          // debugger;
          this.socket.emitEvent('notify', {});
          this._service.apiDelete(this._service.baseUrl + 'notification-delete/' + value._id).subscribe({
            next: result => {
              if (result['status']) {

                if (this.notificationsList.length > 0) {
                  let index = this.notificationsList.findIndex(ntf => ntf._id == value._id);
                  if (index != -1) {
                    this.notificationsList.splice(index, 1);
                    this.notificationsList.length == 0 ? this.isNotificationNotFound = true : this.isNotificationNotFound = false;
                  }
                } else {
                  this.isNotificationNotFound = true;
                }
                this.toaster.Success(result['message']);
              } else {
                this.toaster.Error(result['message']);
              }
            }, error: err => {
              let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
              this.toaster.Error(msg);
            }
          });
        } else {

        }
      });

  }

  //deleteContact for delete contact...
  // deleteContact() {
  //   if (this.detail._id) {
  //     this._service.apiDelete(this._service.baseUrl + 'contact-delete/' + this.detail._id).subscribe({
  //       next: result => {
  //         if (result['status']) {
  //           if (this.contactList.length > 0) {
  //             let index = this.contactList.findIndex(contact => contact._id == this.detail._id);
  //             if (index != -1) {
  //               this.contactList.splice(index, 1);
  //               this.contactList.length == 0 ? this.isContactNotFound = true : this.isContactNotFound = false;
  //             }
  //           } else {
  //             this.isContactNotFound = true;
  //           }
  //           this.toaster.Success(result['message']);
  //         } else {
  //           this.toaster.Error(result['message']);
  //         }
  //       }, error: err => {
  //         let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
  //         this.toaster.Error(msg);
  //       }
  //     });
  //   }
  // }


  deleteContact() {
    if (this.detail?._id) { // Use optional chaining
      // Show SweetAlert confirmation dialog
      Swal.fire({
        title: 'Confirm Deletion',
        text: "This action will permanently delete the contact. Are you sure you want to proceed?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          // Proceed with the delete operation if confirmed
          this._service.apiDelete(this._service.baseUrl + 'contact-delete/' + this.detail._id).subscribe({
            next: result => {
              if (result['status']) {
                if (this.contactList.length > 0) {
                  let index = this.contactList.findIndex(contact => contact._id == this.detail._id);
                  if (index != -1) {
                    this.contactList.splice(index, 1);
                    this.contactList.length === 0 ? this.isContactNotFound = true : this.isContactNotFound = false;
                  }
                } else {
                  this.isContactNotFound = true;
                }
                this.toaster.Success(result['message']);
              } else {
                this.toaster.Error(result['message']);
              }
            },
            error: err => {
              let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
              this.toaster.Error(msg);
            }
          });
        }
      });
    } else {
      this.toaster.Error("Contact details not found.");
    }
  }



  //getContactList for get contact list....
  getFavoritePlaces() {
    this._service.apiGet(this._service.baseUrl + 'fav-get').subscribe({
      next: result => {
        if (result.status && result.data.length > 0) {
          //here we will catch response...
          this.isPlacesNotFound = false;
          this.placesList = result.data;
          this.isLoading = false;
        } else {
          this.isPlacesNotFound = true;
        }
      }, error: err => {
        let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
        this.isLoading = false;
        this.toaster.Error(msg);
      }, complete: () => {
        this.isLoading = false;
      }
    });
  }

  //getContactList for get contact list....
  getNotificationsList() {
    this.isLoading = true;
    var apiparam = {
      "sortBy": 1
    }
    this._service.apiPost(this._service.baseUrl + 'notifications/' + this.notificationOffset, apiparam).subscribe({
      next: result => {
        if (result['status'] && result.data.notifications.length > 0) {
          this.isPlacesNotFound = false;
          this.notificationsList = result.data.notifications;
          this.isNotiNext = result.data.isNext;
          this.isNotiPrev = result.data.isPrevious;
          this.isLoading = false;
          this.readAllNotification();
        } else {
          this.isPlacesNotFound = true;
        }
      }, error: err => {
        let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
        this.isLoading = false;
        this.toaster.Error(msg);
      }, complete: () => {
        this.isLoading = false;
      }
    });
  }
  readAllNotification() {
    var notificationCount = 0;
    if (JSON.parse(localStorage.getItem('userData')) != null) {
      notificationCount = JSON.parse(localStorage.getItem('userData')).unreadNotification;
    }
    if (this.isNotificationReaded || notificationCount < 1) { return }
    this._service.apiGet(this._service.baseUrl + 'read-all-notifications').subscribe({
      next: result => {
        this.isNotificationReaded = true;
        console.log(result);
        this.cmnFunction.getUserDetails().subscribe({
          next: result => {
            if (result.status) {
              var currentUseInfo = result.data;
              this.cmnFunction.userInfo.next(currentUseInfo);
              //here we will store the data in the stroage....
              this.storage.saveDataInStorage(result.data);
            }
          },
          error: err => {
          },
          complete: () => { }
        });
      }, error: err => {
        // this.toaster.Error(err.mesage);
        console.log(err.mesage)
      }
    });
  }
  prevNotifications() {
    this.notificationOffset--;
    this.getNotificationsList();
  }
  nextNotifications() {
    this.notificationOffset++;
    this.getNotificationsList();
  }

  //fetchSettingViaToken for get setting...
  fetchSettingViaToken() {
    this.isLoadData = true;
    this._service.apiGet(this._service.baseUrl + 'setting').subscribe({
      next: result => {
        if (result.status) {
          this.isLoadData = false;
          this.settingObject = result.data;
        }
      }, error: err => {
        this.isLoadData = false;
        this.toaster.Error(err.mesage);
      }
    });
  }

  updateSetting(event: any, key: any) {
    if (event.target) {
      var postData;
      //manage via role wise...
      if (this.role == 'Customer') {
        switch (key) {
          case 'wallet':
            this.settingObject.amountDeduction = event.target.checked;
            break;
          case 'reached':
            this.settingObject.reachedDestination = event.target.checked;
            break;
          case 'begin':
            this.settingObject.journeyBegin = event.target.checked;
            break;
          default:
            this.settingObject.driverReached = event.target.checked;
            break;
        }
        //below we post data in API...
        postData = {
          "amountDeduction": this.settingObject.amountDeduction,
          "reachedDestination": this.settingObject.reachedDestination,
          "journeyBegin": this.settingObject.journeyBegin,
          "driverReached": this.settingObject.driverReached
        }
      } else {
        switch (key) {
          case 'payment':
            this.settingObject.paymentReceived = event.target.checked;
            break;
          case 'feedback':
            this.settingObject.feedbackReceived = event.target.checked;
            break;
          case 'cancel':
            this.settingObject.canceledRide = event.target.checked;
            break;
          default:
            this.settingObject.paymentWithdraw = event.target.checked;
            break;
        }

        //below we post data in API...
        postData = {
          "paymentReceived": this.settingObject.paymentReceived,
          "feedbackReceived": this.settingObject.feedbackReceived,
          "canceledRide": this.settingObject.canceledRide,
          "paymentWithdraw": this.settingObject.paymentWithdraw
        }
      }
      //apiUpdate for update data...
      this._service.apiUpdate(this._service.baseUrl + 'setting-edit', postData).subscribe({
        next: result => {
          if (result['status']) {
            this.toaster.Success(result['message']);
          }
        }, error: err => {
          this.toaster.Error(err.mesage);
        }
      });
    }
  }

  //deleteContact for delete contact...
  deleteNotification() {
    if (this.detail._id) {
      this._service.apiDelete(this._service.baseUrl + 'notification-delete/' + this.detail._id).subscribe({
        next: result => {
          if (result['status']) {

            if (this.notificationsList.length > 0) {
              let index = this.notificationsList.findIndex(contact => contact._id == this.detail._id);
              if (index != -1) {
                this.notificationsList.splice(index, 1);
                this.notificationsList.length == 0 ? this.isContactNotFound = true : this.isContactNotFound = false;
              }
            } else {
              this.isContactNotFound = true;
            }
            this.toaster.Success(result['message']);
          } else {
            this.toaster.Error(result['message']);
          }
        }, error: err => {
          this.toaster.Error(err.message);
        }
      });
    }
  }



  // open(content, id, type, name) {
  //   this.efavAddId = id;
  //   this.formattedaddressEdit = '';
  //   // this.editFavPlaceForm = this.formBuilder.group({
  //   //   type: [type, Validators.required],
  //   //   name: [name, [Validators.required]],
  //   // })

  //   this.editFavPlaceForm = new FormGroup({
  //     type: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
  //     name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
  //   });

  //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

  open(content, id: string, type: string, name: string) {
    this.efavAddId = id;
    this.formattedaddressEdit = '';
    this.submittedEdit = false; // Reset submitted state when opening modal

    // Initialize the form with initial values (type, name) and the validators
    this.editFavPlaceForm = new FormGroup({
      type: new FormControl(type, [Validators.required, this.noWhitespaceValidator]),
      name: new FormControl(name, [Validators.required, this.noWhitespaceValidator]),
    });

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    this.editFavPlaceForm.reset;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
